import { useEffect } from 'react'
import { clearError } from '../state/root/rootSlice';
import { useDispatch } from 'react-redux'
import { messageFromData, GENERIC_ERROR } from '../helpers/api-error';

import Swal from 'sweetalert2';

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  iconColor: 'white',
  customClass: {
    popup: 'colored-toast',
  },
  showConfirmButton: false,
  timer: 4000,
  timerProgressBar: true,
})

export default function Alert ({ successMessage, error }) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (error) {
      // `error` can be a string, an object of many shapes, or an array —
      // always resolve to a non-empty title so we never show a blank toast.
      const title = messageFromData(error) || GENERIC_ERROR;
      Toast.fire({
        icon: 'error',
        iconColor: 'red',
        title,
      })
      setTimeout(function () {
        dispatch(clearError());
      }, 4000);
    }

    if (successMessage) {
      // toastr.success('Success', successMessage)
      Toast.fire({
        icon: 'success',
        iconColor: 'green',
        title: successMessage,
      })
      setTimeout(function () {
        dispatch(clearError());
      }, 2000);
    }
  }, [error, successMessage, dispatch])

  return null
}
